import { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { Header, AuthLink, FormContainer } from './shared'
import ResendConfirmationForm from './ResendConfirmationForm'

const Wrapper = styled.div``

class ResendConfirmation extends Component {
  render() {
    return (
      <Wrapper>
        <Header>
          <AuthLink to="/resend-confirmation">
            <strong>Resend</strong> confirmation
          </AuthLink>
        </Header>
        <FormContainer>
          <ResendConfirmationForm />
        </FormContainer>
      </Wrapper>
    )
  }
}

export default connect()(ResendConfirmation)
